module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_5012.3724f409.png";